// useOrderActions.ts
import { useOrdersStore } from "../store/orders-store";

export const useOrderActions = () => {
  const addItem = useOrdersStore((s) => s.addItem);
  const incrementItem = useOrdersStore((s) => s.incrementItem);
  const decrementItem = useOrdersStore((s) => s.decrementItem);
  const removeItem = useOrdersStore((s) => s.removeItem);
  const updateItem = useOrdersStore((s) => s.updateItem);
  const clear = useOrdersStore((s) => s.clear);


  return {
    addItem,
    incrementItem,
    decrementItem,
    removeItem,
    updateItem,
    clear,

  };
};